import(/* webpackMode: "eager", webpackExports: ["AnimatedSection"] */ "/vercel/path0/src/app/(frontend)/components/HomePageAnimations/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VisaListHero"] */ "/vercel/path0/src/app/(frontend)/components/VisaListHero/index.tsx");
